import {
  UPDATED_APP_STATUS,
  UPDATE_APP_STATUS,
  CLOSED_FORM,
  OPENED_FORM
} from "../actions/appStatus";
import { appStatusInitialState } from "../state/initialState";
import objectAssign from "object-assign";
export default (state = appStatusInitialState, action) => {
  let newStatus;
  switch (action.type) {
    case UPDATED_APP_STATUS:
      newStatus = {
        currentFormState: action.data,
        navigating: false
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_APP_STATUS:
      newStatus = {
        navigating: true
      };
      return objectAssign({}, state, newStatus);
    case CLOSED_FORM:
      newStatus = {
        appIsVisible: false
      };
      return objectAssign({}, state, newStatus);
    case OPENED_FORM:
      newStatus = {
        appIsVisible: true,
        form: action.form
      };
      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
  return state;
};
